import React from 'react';
import AboutBanner from '../About/About-Banner/AboutBanner'
import WhoAreWe from './WhoAreWe/WhoAreWe';
import Director from './Director/Director';
import Faculty from './Faculty/Faculty';

function About() {
  return (
    <>
     <AboutBanner/>
     <WhoAreWe/>
     <Director/>
     <Faculty/>
    </>
  )
}

export default About
